import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import TopBar from "./components/TopBar";
import useResponsive from "../userDashboard/ResponsiveHook.jsx";
import { useTheme } from "../ThemeContext";

export default function CompanyDashboard() {
  const { isMobile } = useResponsive();
  const location = useLocation();
  const { C } = useTheme();

  // Extract the page name for the TopBar title
  const path = location.pathname.split("/").pop();
  const currentPage = path === "company" || !path ? "dashboard" : path;

  return (
    <div style={{ 
      display: "flex", 
      flexDirection: isMobile ? "column" : "row", 
      minHeight: "100vh", 
      background: C.bgDeep, 
      color: C.textPrimary,
      fontFamily: "'DM Sans', 'Inter', sans-serif",
      overflowX: "hidden",
      transition: "background 0.3s ease, color 0.3s ease"
    }}>
      {!isMobile && <Sidebar />}
      <link href="https://fonts.googleapis.com/css2?family=Space+Mono:wght@400;700&family=DM+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
      
      <main style={{ 
        marginLeft: isMobile ? 0 : 240,
        width: isMobile ? "100%" : "calc(100% - 240px)",
        flex: 1, 
        display: "flex", 
        flexDirection: "column", 
        minHeight: "100vh",
        position: "relative"
      }}>
        {!isMobile && <TopBar page={currentPage} />}
        <div style={{ flex: 1, width: "100%" }}>
          <Outlet />
        </div>
      </main>
    </div>
  );
}